<template>
  <div class = "footers" >
    <div class="footBox">
      <ul class = 'rowList'>
        <li class="title">相关链接</li>
        <li class="content"><a style="cursor: pointer;" @click="Goto()">地理标志产品特色品质综合信息平台</a></li>
        <li class="content"><a style="cursor: pointer;" @click="Goto1()"  target="_blank">化学物质特征数据库</a></li>
        <li class="content"><a href = 'http://beian.miit.gov.cn' target="_blank">工信部备案号 : 京ICP备16043075号-8</a></li>
      </ul>
      <ul class = 'rowList'>
        <li class="title">技术团队</li>
        <!-- <li class="content">中国农业科学院农业质量标准与检测技术研究所</li> -->
        <li class="content"><a  href = 'https://iqstap.caas.cn' target="_blank">中国农业科学院农业质量标准与检测技术研究所</a></li>
        <li class="content">农产品质量安全风险评估创新团队</li>
        <li class="content">联系地址：北京市海淀区中关村南大街12号</li>
        <li class="content">联系邮箱：quselchem@caas.com</li>
      </ul>
      <ul class = 'rowList'>
        <li class="title">运营团队</li>
        <li class="content"><a href = 'https://xmfengkong.com/index' target="_blank">北京新盟风控科技有限公司</a></li>
        <!-- <li class="content">北京新盟风控科技有限公司</li> -->
        <li class="content">联系地址：北京市海淀区北清路81号院中关村壹号B1座9层</li>
        <li class="content">联系电话：010-62148792</li>
        <li class="content">联系邮箱：service@fengkonglm.com</li>
      </ul>
    </div>
  </div>
</template>



<script>

export default {
  data () {
    return {
    
     
    };
  },
  methods: {
    Goto(){
      if (process.env.BUILD_FLAG === 'test') {//测试部署
        // console.log(rootDomain,'rootDomain')
        window.open(`${rootDomain}/collect/dlbzLogin`);
      } else if (process.env.BUILD_FLAG === 'production') {//生产环境部署
        window.open(`https://admin.quselchem.com/collect/dlbzLogin`);
      } else{
        window.open(`https://admin.quselchem.com/collect/dlbzLogin`);
      }
    },
    Goto1(){
      if (process.env.BUILD_FLAG === 'test') {//测试部署
        window.open(`${rootDomain}/hxhy/home/homePage`);
      } else if (process.env.BUILD_FLAG === 'production') {//生产环境部署
        window.open(`https://quselchem.com/hxhy/home/homePage`);
      } else{
        // window.open(`www.quselchem.com/hxhy/home/homePage`);
        window.open(`https://quselchem.com/hxhy/home/homePage`);

      }
    },
   
  },
  created () { },
  mounted () {
    this.$nextTick(() => {
     
    });
  },
};
</script>

<style lang="less" scoped>

    .footers{
      height: 170px;
	    background-color: #151b26;
      .footBox{
        min-width:1180px;
        max-width: 80%;
        height:170px;
        margin:0 auto;
        display: flex;
        justify-content: space-between;
        padding-top:20px;
        box-sizing: border-box;
        .rowList{
          display: flex;
          flex-direction: column;
          .title{
            width: 68px;
            height: 24px;
            font-family: PingFangSC-Semibold;
            font-size: 17px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #ffffff;
          }
          .content{
            font-family: PingFangSC-Regular;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;
            color: #96a1b9;
            margin-top:10px;
            a{
              color: #96a1b9;
            }
          }
        }
      }
      
    }
  

    
  

</style>






// WEBPACK FOOTER //
// src/components/footers/footers.vue